import React, { useState } from 'react'
import Modal from '../common/Modal'
import SemanticModelsPanel from './SemanticModelsPanel'

interface SettingsModalProps {
  isOpen: boolean
  onClose: () => void
}

type Category = 'semantic-models'

const CATEGORIES: { id: Category; label: string }[] = [
  { id: 'semantic-models', label: 'Semantic Models' },
]

const SettingsModal: React.FC<SettingsModalProps> = ({ isOpen, onClose }) => {
  const [active, setActive] = useState<Category>('semantic-models')

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Settings" className="settings">
      <div className="settings__layout">
        <nav className="settings__sidebar">
          {CATEGORIES.map(cat => (
            <button
              key={cat.id}
              className={`settings__category ${
                active === cat.id ? 'settings__category--active' : ''
              }`}
              onClick={() => setActive(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </nav>
        <div className="settings__panel">
          {active === 'semantic-models' && <SemanticModelsPanel />}
        </div>
      </div>
    </Modal>
  )
}

export default SettingsModal
